// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ImageLargeFragmentDoc } from '../imageLarge.fragment.generated';
import { ContentComponentItemFragmentDoc } from './ContentComponentItem.fragment.generated';
export const ComponentCardFragmentDoc = gql`
    fragment componentCard on ComponentCard {
  cardImage: image {
    ...imageLarge
  }
  content {
    ...contentComponentItem
  }
  backgroundColor
}
    ${ImageLargeFragmentDoc}
${ContentComponentItemFragmentDoc}`;